import { render, staticRenderFns } from "./Multiple.vue?vue&type=template&id=2c71851c&"
import script from "./Multiple.vue?vue&type=script&lang=js&"
export * from "./Multiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports